module.exports = __webpack_public_path__ + "media/images/1_after-73e12100fbfd819719d99452cc61bdc3.webp";